import axios from 'axios';
import { temporaryDomain } from 'http/endpoints';

const xApiKey = process.env.REACT_APP_POSTMAN_API_KEY;

const setBaseUrl = (): void => {
  const isLocalHost = window.location.hostname === 'localhost';
  axios.defaults.baseURL = isLocalHost
    ? 'http://localhost'
    : window.location.origin;
};

const setCredentialConfiguration = (): void => {
  // axios.defaults.withCredentials = true;
};

const setHeaders = (): void => {
  // axios.defaults.headers.common.Authorization = 'AUTH_TOKEN';
  // axios.defaults.headers.post['Content-Type'] = 'application/json';
};

const setRequestInterceptors = (debug?: boolean): void => {
  axios.interceptors.request.use(
    (req) => {
      // eslint-disable-next-line no-console
      if (req.url?.includes(temporaryDomain)) {
        req.headers.common['x-api-key'] = xApiKey;
      }
      if (debug) console.log('req', req);
      return req;
    },
    (error) => {
      // eslint-disable-next-line no-console
      console.warn('Request Interceptors Error:', error);
      return Promise.reject(error);
    }
  );
};

const setResponseInterceptors = (debug?: boolean): void => {
  axios.interceptors.response.use(
    (res) => {
      // eslint-disable-next-line no-console
      if (debug) console.log('Response Interceptors:', res);
      const isResponseDataString = typeof res.data === 'string';
      const isResponseDataHTML = /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(
        res.data
      );
      if (isResponseDataString && isResponseDataHTML) {
        // 302 redirect - https://www.sean-lan.com/2017/08/15/fetch-meets-302/
        // eslint-disable-next-line no-console
        console.warn(`Response for: ${res.config.url}`, '302 redirect');
        // eslint-disable-next-line no-console
        const error = new Error('302 redirect');
        return Promise.reject(error);
      }
      return res;
    },
    (error) => {
      // eslint-disable-next-line no-console
      console.warn('Response Interceptors Error:', error);
      return Promise.reject(error);
    }
  );
};

const setAxiosGlobalConfiguration = (): void => {
  setBaseUrl();
  setHeaders();
  setCredentialConfiguration();
  setRequestInterceptors();
  setResponseInterceptors();
};

export default setAxiosGlobalConfiguration;
